import mapValues from 'lodash-es/mapValues'

import { BirdviewSection } from '../DashboardBirdview.constants'
import {
  checkIsBirdviewChatsViewable,
  checkIsBirdviewDwellerDocumentsViewable,
  checkIsBirdviewLandlordRole,
} from '../DashboardBirdview.utils'
import { getBirdviewSection } from '../DashboardBirdview.utils.sections'

import {
  BIRDVIEW_DWELLER_HOME_ITEMS_LIMIT,
  BIRDVIEW_DWELLER_LAYOUT,
  BIRDVIEW_LANDLORD_LAYOUT,
  BirdviewDwellerWidget,
} from './BirdviewDweller.constants'

// Gated by the same section permissions as their menu entries.
function getBirdviewDwellerHiddenWidgets(sectionsPermissions) {
  return [
    checkIsBirdviewChatsViewable(sectionsPermissions)
      ? null
      : BirdviewDwellerWidget.Messages,
    checkIsBirdviewDwellerDocumentsViewable(sectionsPermissions)
      ? null
      : BirdviewDwellerWidget.Documents,
  ].filter(Boolean)
}

export function getBirdviewDwellerLayout(role, sectionsPermissions) {
  const layout = checkIsBirdviewLandlordRole(role)
    ? BIRDVIEW_LANDLORD_LAYOUT
    : BIRDVIEW_DWELLER_LAYOUT

  const hiddenWidgets = getBirdviewDwellerHiddenWidgets(sectionsPermissions)

  return hiddenWidgets.length > 0
    ? mapValues(layout, column =>
        column.filter(widget => !hiddenWidgets.includes(widget))
      )
    : layout
}

export function getBirdviewDwellerSections(sections) {
  return {
    announcements: getBirdviewSection(
      sections[BirdviewSection.DwellerAnnouncements]
    ),
    documents: getBirdviewSection(sections[BirdviewSection.DwellerDocuments]),
    home: getBirdviewSection(
      sections[BirdviewSection.DwellerHome],
      BIRDVIEW_DWELLER_HOME_ITEMS_LIMIT
    ),
    messages: getBirdviewSection(sections[BirdviewSection.DwellerMessages]),
    objects: getBirdviewSection(sections[BirdviewSection.DwellerObjects]),
    requests: getBirdviewSection(sections[BirdviewSection.DwellerRequests]),
  }
}
